export default class MAANav extends HTMLElement {
  constructor() {
    super();
    console.log('Init MAANav');
    this.attachShadow({ mode: 'open' });
    this.menuBtn = this.shadowRoot.querySelector('[menuBtn]');
  }

  get type() {
      return this.getAttribute('type');
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  _toggleMenu()
  {
    alert('_toggleMenu');
  }

  connectedCallback() {
    switch(this.type)
    {
        case `top`:
                this.menuBtn.addEventListener('click', this._toggleMenu);
                this.innerHTML = `
                        <ul>
                            <li class="logo"><img src="images/fw-avatar.svg" alt="Farmers Weekly"></li>
                            <li class="menu"><a href="#" data-route="" class="icon-menu" menuBtn><span>Menu<span></a></li>
                            <li class="title"><span>Title</span></li>
                            <li class="taskbar"><span>Task Bar</span></li>
                        </ul>
                `;
                break;
        case `primary`:
                this.innerHTML = `
                        <ul>
                            <li>1</li>
                            <li>3</li>
                        </ul>
                `;
                break;
    }
  }
}

